import React from 'react';

import { LinkButton, StandardButton } from '@eika/button';

import piwik from '@/piwik/piwik';

import useText from '@hooks/use-text';

interface FooterProps {
    permissionGiven: boolean;
    pushProvisionSuccess: boolean;
    confirmPermission: () => void;
    close: () => void;
}

const Footer: React.FC<FooterProps> = ({ permissionGiven, confirmPermission, close, pushProvisionSuccess }) => {
    const { formConfirm, formCancel, formBack } = useText();

    if (permissionGiven) {
        return null;
    }

    if (pushProvisionSuccess) {
        return (
            <footer className="confirm-google-pay-activation-permission-modal__footer">
                <LinkButton
                    data-track-id={piwik.googlePay.pushProvisionSuccessCloseButton.dataTrackId}
                    data-track-linkname={piwik.googlePay.pushProvisionSuccessCloseButton.dataTrackLinkname}
                    onClick={() => close()}
                >
                    {formBack}
                </LinkButton>
            </footer>
        );
    }

    return (
        <footer className="confirm-google-pay-activation-permission-modal__footer">
            <StandardButton
                data-track-id={piwik.googlePay.pushProvisionConfirmPermissionButton.dataTrackId}
                data-track-linkname={piwik.googlePay.pushProvisionConfirmPermissionButton.dataTrackLinkname}
                onClick={() => confirmPermission()}
            >
                {formConfirm}
            </StandardButton>
            <LinkButton
                data-track-id={piwik.googlePay.pushProvisionCancelButton.dataTrackId}
                data-track-linkname={piwik.googlePay.pushProvisionCancelButton.dataTrackLinkname}
                onClick={() => close()}
            >
                {formCancel}
            </LinkButton>
        </footer>
    );
};

export default Footer;
